/**
 * Executes logic only when a given function is satisfied.
 * @param doHandler The logic to execute.
 * @param whenHandler The function to test.
 * @param maxIteration Optional maximum number of iterations to attempt. Default is 20.
 * @param timeout Optional timeout between attempts. Default is 50ms.
 * @param delay Optional additional delay.
 * @param iteration The current iteration, not to be passed directly by the caller.
 */
export function doWhen(doHandler: () => void, whenHandler: () => boolean, maxIteration?: number, timeout?: number, delay?: number, iteration?: number) {

	if (!maxIteration) maxIteration = 20;
	if (!timeout) timeout = 50;

	const ensuredIteration = iteration ?? 0;   

	// check the when handler to see if execution can be performed yet
	if (whenHandler()) {

		if (delay) {
			setTimeout(() => {
				doHandler();
			}, delay);
		}
		else {
			doHandler();
		}
	}
	// check max iteration
	else if (ensuredIteration < maxIteration) {

		// try again
		setTimeout(() => {
			doWhen(doHandler, whenHandler, maxIteration, timeout, delay, ensuredIteration + 1);
		}, timeout);
	}
}